const FALLBACK_LOCALE = "en";
export const UI_STRINGS = {
    live_tv: {
        en: "Live TV",
        sv: "Live-TV",
        no: "Direkte-TV",
        da: "Live-tv",
        fi: "Suora TV",
        de: "Live-TV",
        fr: "TV en direct",
        es: "TV en directo",
        it: "TV in diretta",
        nl: "Live-tv",
        pt: "TV ao vivo",
        pl: "Telewizja na żywo",
        ru: "Прямой эфир",
        zh: "直播电视",
        ja: "ライブTV",
        ar: "البث المباشر",
    },
    live_tv_sub: {
        en: "See what’s on right now",
        sv: "Se vad som sänds just nu",
        no: "Se hva som sendes nå",
        da: "Se hvad der sendes lige nu",
        fi: "Katso, mitä juuri nyt näytetään",
        de: "Sehen Sie, was gerade läuft",
        fr: "Découvrez ce qui passe en ce moment",
        es: "Mira qué están dando ahora",
        it: "Guarda cosa c’è in onda ora",
        nl: "Zie wat er nu op tv is",
        pt: "Veja o que está passando agora",
        pl: "Zobacz, co jest teraz na antenie",
        ru: "Узнайте, что идёт сейчас",
        zh: "查看正在播放的节目",
        ja: "今放送中の番組を見る",
        ar: "شاهد ما يُعرض الآن",
    },
    apps: {
        en: "Apps",
        sv: "Appar",
        no: "Apper",
        da: "Apps",
        fi: "Sovellukset",
        de: "Apps",
        fr: "Applications",
        es: "Aplicaciones",
        it: "App",
        nl: "Apps",
        pt: "Aplicativos",
        pl: "Aplikacje",
        ru: "Приложения",
        zh: "应用",
        ja: "アプリ",
        ar: "التطبيقات",
    },
    radio: {
        en: "Radio",
        sv: "Radio",
        no: "Radio",
        da: "Radio",
        fi: "Radio",
        de: "Radio",
        fr: "Radio",
        es: "Radio",
        it: "Radio",
        nl: "Radio",
        pt: "Rádio",
        pl: "Radio",
        ru: "Радио",
        zh: "广播",
        ja: "ラジオ",
        ar: "الراديو",
    },
    instagram: {
        en: "Instagram",
    },
    weather: {
        en: "Weather",
        sv: "Väder",
        no: "Vær",
        da: "Vejr",
        fi: "Sää",
        de: "Wetter",
        fr: "Météo",
        es: "El tiempo",
        it: "Meteo",
        nl: "Weer",
        pt: "Tempo",
        pl: "Pogoda",
        ru: "Погода",
        zh: "天气",
        ja: "天気",
        ar: "الطقس",
    },
    wifi: {
        en: "Wi-Fi",
    },
    network: {
        en: "Network",
        sv: "Nätverk",
        no: "Nettverk",
        da: "Netværk",
        fi: "Verkko",
        de: "Netzwerk",
        fr: "Réseau",
        es: "Red",
        it: "Rete",
        nl: "Netwerk",
        pt: "Rede",
        pl: "Sieć",
        ru: "Сеть",
        zh: "网络",
        ja: "ネットワーク",
        ar: "الشبكة",
    },
    password: {
        en: "Password",
        sv: "Lösenord",
        no: "Passord",
        da: "Adgangskode",
        fi: "Salasana",
        de: "Passwort",
        fr: "Mot de passe",
        es: "Contraseña",
        it: "Password",
        nl: "Wachtwoord",
        pt: "Senha",
        pl: "Hasło",
        ru: "Пароль",
        zh: "密码",
        ja: "パスワード",
        ar: "كلمة المرور",
    },
    follow: {
        en: "Follow",
        sv: "Följ",
        no: "Følg",
        da: "Følg",
        fi: "Seuraa",
        de: "Folgen",
        fr: "Suivre",
        es: "Seguir",
        it: "Segui",
        nl: "Volgen",
        pt: "Seguir",
        pl: "Obserwuj",
        ru: "Подписаться",
        zh: "关注",
        ja: "フォロー",
        ar: "تابِع",
    },
    language: {
        en: "Language",
        sv: "Språk",
        no: "Språk",
        da: "Sprog",
        fi: "Kieli",
        de: "Sprache",
        fr: "Langue",
        es: "Idioma",
        it: "Lingua",
        nl: "Taal",
        pt: "Idioma",
        pl: "Język",
        ru: "Язык",
        zh: "语言",
        ja: "言語",
        ar: "اللغة",
    },
    for_family: {
        en: "For family",
        sv: "För anhöriga",
        no: "For pårørende",
        da: "For pårørende",
        fi: "Omaisille",
        de: "Für Angehörige",
        fr: "Pour la famille",
        es: "Para familiares",
        it: "Per i familiari",
        nl: "Voor familie",
        pt: "Para familiares",
        pl: "Dla rodziny",
        ru: "Для близких",
        zh: "家属信息",
        ja: "ご家族へ",
        ar: "للعائلة",
    },
    play: {
        en: "Play",
        sv: "Spela",
        no: "Spill",
        da: "Afspil",
        fi: "Toista",
        de: "Wiedergabe",
        fr: "Lire",
        es: "Reproducir",
        it: "Riproduci",
        nl: "Afspelen",
        pt: "Reproduzir",
        pl: "Odtwórz",
        ru: "Воспроизвести",
        zh: "播放",
        ja: "再生",
        ar: "تشغيل",
    },
    stop: {
        en: "Stop",
        sv: "Stoppa",
        no: "Stopp",
        da: "Stop",
        fi: "Pysäytä",
        de: "Stopp",
        fr: "Arrêter",
        es: "Detener",
        it: "Ferma",
        nl: "Stoppen",
        pt: "Parar",
        pl: "Zatrzymaj",
        ru: "Остановить",
        zh: "停止",
        ja: "停止",
        ar: "إيقاف",
    },
    loading: {
        en: "Loading",
        sv: "Laddar",
        no: "Laster",
        da: "Indlæser",
        fi: "Ladataan",
        de: "Wird geladen",
        fr: "Chargement",
        es: "Cargando",
        it: "Caricamento",
        nl: "Laden",
        pt: "Carregando",
        pl: "Ładowanie",
        ru: "Загрузка",
        zh: "加载中",
        ja: "読み込み中",
        ar: "جارٍ التحميل",
    },
    privacy: {
        en: "Privacy",
        sv: "Integritet",
        no: "Personvern",
        da: "Privatliv",
        fi: "Tietosuoja",
        de: "Datenschutz",
        fr: "Confidentialité",
        es: "Privacidad",
        it: "Privacy",
        nl: "Privacy",
        pt: "Privacidade",
        pl: "Prywatność",
        ru: "Конфиденциальность",
        zh: "隐私",
        ja: "プライバシー",
        ar: "الخصوصية",
    },
    privacy_text: {
        en: "No account, no personal data. We count anonymous, aggregate usage (page and section views) to improve this page - no tracking across sites, no device fingerprinting.",
        sv: "Inget konto, inga personuppgifter. Vi räknar anonym, aggregerad användning (sid- och sektionsvisningar) för att förbättra sidan - ingen spårning mellan webbplatser, ingen enhetsidentifiering.",
    },
    open_where: {
        en: "Where would you like to open it?",
        sv: "Var vill du öppna?",
        no: "Hvor vil du åpne den?",
        da: "Hvor vil du åbne den?",
        fi: "Missä haluat avata sen?",
        de: "Wo möchten Sie es öffnen?",
        fr: "Où souhaitez-vous l’ouvrir ?",
        es: "¿Dónde quieres abrirlo?",
        it: "Dove vuoi aprirlo?",
        nl: "Waar wilt u het openen?",
        pt: "Onde deseja abrir?",
        pl: "Gdzie chcesz to otworzyć?",
        ru: "Где открыть?",
        zh: "您想在哪里打开？",
        ja: "どこで開きますか？",
        ar: "أين تريد فتحه؟",
    },
    open_on_device: {
        en: "On this device",
        sv: "På den här enheten",
        no: "På denne enheten",
        da: "På denne enhed",
        fi: "Tällä laitteella",
        de: "Auf diesem Gerät",
        fr: "Sur cet appareil",
        es: "En este dispositivo",
        it: "Su questo dispositivo",
        nl: "Op dit apparaat",
        pt: "Neste dispositivo",
        pl: "Na tym urządzeniu",
        ru: "На этом устройстве",
        zh: "在此设备上",
        ja: "この端末で",
        ar: "على هذا الجهاز",
    },
    open_on_tv: {
        en: "On your TV",
        sv: "På din TV",
        no: "På TV-en din",
        da: "På dit tv",
        fi: "Televisiossasi",
        de: "Auf Ihrem TV",
        fr: "Sur votre TV",
        es: "En tu TV",
        it: "Sulla tua TV",
        nl: "Op uw tv",
        pt: "Na sua TV",
        pl: "Na telewizorze",
        ru: "На телевизоре",
        zh: "在电视上",
        ja: "テレビで",
        ar: "على التلفزيون",
    },
    cancel: {
        en: "Cancel",
        sv: "Avbryt",
        no: "Avbryt",
        da: "Annullér",
        fi: "Peruuta",
        de: "Abbrechen",
        fr: "Annuler",
        es: "Cancelar",
        it: "Annulla",
        nl: "Annuleren",
        pt: "Cancelar",
        pl: "Anuluj",
        ru: "Отмена",
        zh: "取消",
        ja: "キャンセル",
        ar: "إلغاء",
    },
    tv_opening: {
        en: "Sending to your TV…",
        sv: "Skickar till din TV …",
        no: "Sender til TV-en …",
        da: "Sender til dit tv …",
        fi: "Lähetetään televisioon …",
        de: "Wird an Ihren TV gesendet …",
        fr: "Envoi vers votre TV …",
        es: "Enviando a tu TV …",
        it: "Invio alla TV …",
        nl: "Versturen naar uw tv …",
        pt: "Enviando para a sua TV …",
        pl: "Wysyłanie do telewizora …",
        ru: "Отправляем на телевизор …",
        zh: "正在发送到电视…",
        ja: "テレビに送信中…",
        ar: "جارٍ الإرسال إلى التلفزيون …",
    },
    tv_opened: {
        en: "Opening on your TV",
        sv: "Öppnas på din TV",
        no: "Åpnes på TV-en",
        da: "Åbner på dit tv",
        fi: "Avataan televisiossa",
        de: "Wird auf Ihrem TV geöffnet",
        fr: "Ouverture sur votre TV",
        es: "Abriendo en tu TV",
        it: "Apertura sulla TV",
        nl: "Wordt geopend op uw tv",
        pt: "Abrindo na sua TV",
        pl: "Otwieranie na telewizorze",
        ru: "Открываем на телевизоре",
        zh: "正在电视上打开",
        ja: "テレビで開いています",
        ar: "يتم الفتح على التلفزيون",
    },
    tv_offline: {
        en: "Your TV isn’t responding. Please turn it on and try again.",
        sv: "Din TV svarar inte. Slå på den och försök igen.",
        no: "TV-en svarer ikke. Slå den på og prøv igjen.",
        da: "Dit tv svarer ikke. Tænd det, og prøv igen.",
        fi: "Televisio ei vastaa. Kytke se päälle ja yritä uudelleen.",
        de: "Ihr TV reagiert nicht. Bitte schalten Sie ihn ein und versuchen Sie es erneut.",
        fr: "Votre TV ne répond pas. Allumez-la puis réessayez.",
        es: "Tu TV no responde. Enciéndelo e inténtalo de nuevo.",
        it: "La TV non risponde. Accendila e riprova.",
        nl: "Uw tv reageert niet. Zet hem aan en probeer het opnieuw.",
        pt: "A sua TV não responde. Ligue-a e tente novamente.",
        pl: "Telewizor nie odpowiada. Włącz go i spróbuj ponownie.",
        ru: "Телевизор не отвечает. Включите его и попробуйте снова.",
        zh: "电视无响应。请打开电视后重试。",
        ja: "テレビが応答していません。電源を入れてもう一度お試しください。",
        ar: "التلفزيون لا يستجيب. يرجى تشغيله والمحاولة مرة أخرى.",
    },
    tv_failed: {
        en: "Couldn’t open it on your TV. Please try again.",
        sv: "Kunde inte öppna på din TV. Försök igen.",
        no: "Kunne ikke åpne på TV-en. Prøv igjen.",
        da: "Kunne ikke åbne på dit tv. Prøv igen.",
        fi: "Avaaminen televisiossa ei onnistunut. Yritä uudelleen.",
        de: "Öffnen auf Ihrem TV nicht möglich. Bitte erneut versuchen.",
        fr: "Impossible de l’ouvrir sur votre TV. Veuillez réessayer.",
        es: "No se pudo abrir en tu TV. Inténtalo de nuevo.",
        it: "Impossibile aprirlo sulla TV. Riprova.",
        nl: "Openen op uw tv is mislukt. Probeer het opnieuw.",
        pt: "Não foi possível abrir na sua TV. Tente novamente.",
        pl: "Nie udało się otworzyć na telewizorze. Spróbuj ponownie.",
        ru: "Не удалось открыть на телевизоре. Попробуйте ещё раз.",
        zh: "无法在电视上打开，请重试。",
        ja: "テレビで開けませんでした。もう一度お試しください。",
        ar: "تعذّر الفتح على التلفزيون. يرجى المحاولة مرة أخرى.",
    },
    offers: {
        en: "Offers",
        sv: "Erbjudanden",
        no: "Tilbud",
        da: "Tilbud",
        fi: "Tarjoukset",
        de: "Angebote",
    },
    offer_order: {
        en: "Order",
        sv: "Beställ",
        no: "Bestill",
        da: "Bestil",
        fi: "Tilaa",
        de: "Bestellen",
    },
    offer_book: {
        en: "Book",
        sv: "Boka",
        no: "Bestill tid",
        da: "Book",
        fi: "Varaa",
        de: "Buchen",
    },
    offer_confirm: {
        en: "Confirm",
        sv: "Bekräfta",
        no: "Bekreft",
        da: "Bekræft",
        fi: "Vahvista",
        de: "Bestätigen",
    },
    offer_close: {
        en: "Close",
        sv: "Stäng",
        no: "Lukk",
        da: "Luk",
        fi: "Sulje",
        de: "Schließen",
    },
    offer_sending: {
        en: "Sending…",
        sv: "Skickar…",
        no: "Sender…",
        da: "Sender…",
        fi: "Lähetetään…",
        de: "Wird gesendet…",
    },
    offer_cancel: {
        en: "Cancel request",
        sv: "Avbryt beställning",
        no: "Avbryt bestilling",
        da: "Annullér bestilling",
        fi: "Peruuta tilaus",
        de: "Anfrage stornieren",
    },
    offer_total: {
        en: "Total",
        sv: "Totalt",
        no: "Totalt",
        da: "I alt",
        fi: "Yhteensä",
        de: "Gesamt",
    },
    offer_included: {
        en: "Included",
        sv: "Ingår",
        no: "Inkludert",
        da: "Inkluderet",
        fi: "Sisältyy",
        de: "Inklusive",
    },
    offer_pick_time: {
        en: "Choose a time",
        sv: "Välj en tid",
        no: "Velg et tidspunkt",
        da: "Vælg et tidspunkt",
        fi: "Valitse aika",
        de: "Zeit wählen",
    },
    offer_no_times: {
        en: "No times left",
        sv: "Inga tider kvar",
        no: "Ingen ledige tider",
        da: "Ingen ledige tider",
        fi: "Ei vapaita aikoja",
        de: "Keine Zeiten frei",
    },
    offer_deliver: {
        en: "To your room",
        sv: "Till ditt rum",
        no: "Til rommet ditt",
        da: "Til dit værelse",
        fi: "Huoneeseesi",
        de: "Auf Ihr Zimmer",
    },
    offer_desk: {
        en: "At reception",
        sv: "I receptionen",
        no: "I resepsjonen",
        da: "I receptionen",
        fi: "Vastaanotossa",
        de: "An der Rezeption",
    },
    offer_your_requests: {
        en: "Your requests",
        sv: "Dina beställningar",
        no: "Dine bestillinger",
        da: "Dine bestillinger",
        fi: "Tilauksesi",
        de: "Ihre Anfragen",
    },
    offer_note: {
        en: "Anything we should know? (optional)",
        sv: "Något vi bör veta? (frivilligt)",
    },
    offer_charged_to_room: {
        en: "Charged to your room.",
        sv: "Debiteras ditt rum.",
    },
    offer_ask_reception: {
        en: "Scan the code in your room to order this, or ask reception.",
        sv: "Skanna koden i ditt rum för att beställa, eller fråga receptionen.",
    },
    offer_card_unavailable: {
        en: "Card payment isn’t available yet.",
        sv: "Kortbetalning är inte tillgänglig än.",
    },
    offer_status_pending: {
        en: "With reception",
        sv: "Hos receptionen",
        no: "Hos resepsjonen",
        da: "Hos receptionen",
        fi: "Vastaanotossa käsittelyssä",
        de: "Bei der Rezeption",
    },
    offer_status_accepted: {
        en: "Confirmed",
        sv: "Bekräftad",
        no: "Bekreftet",
        da: "Bekræftet",
        fi: "Vahvistettu",
        de: "Bestätigt",
    },
    offer_status_completed: {
        en: "Done",
        sv: "Klar",
        no: "Fullført",
        da: "Færdig",
        fi: "Valmis",
        de: "Erledigt",
    },
    offer_status_declined: {
        en: "Not possible",
        sv: "Inte möjligt",
        no: "Ikke mulig",
        da: "Ikke muligt",
        fi: "Ei onnistu",
        de: "Nicht möglich",
    },
    offer_status_cancelled: {
        en: "Cancelled",
        sv: "Avbruten",
        no: "Avbrutt",
        da: "Annulleret",
        fi: "Peruutettu",
        de: "Storniert",
    },
    offer_status_refunded: {
        en: "Refunded",
        sv: "Återbetald",
        no: "Refundert",
        da: "Refunderet",
        fi: "Hyvitetty",
        de: "Erstattet",
    },
    offer_err_slot_taken: {
        en: "That time has just been taken. Please choose another.",
        sv: "Den tiden är precis tagen. Välj en annan.",
    },
    offer_err_unavailable: {
        en: "This isn’t available right now. Please ask reception.",
        sv: "Det här går inte att beställa just nu. Fråga gärna receptionen.",
    },
    offer_err_generic: {
        en: "That didn’t go through. Please try again.",
        sv: "Det gick inte igenom. Försök igen.",
    },
    err_checked_out_title: {
        en: "Your stay has ended",
        sv: "Din vistelse har avslutats",
    },
    err_checked_out_body: {
        en: "This room is checked out. Thank you for staying with us - please ask reception if you need anything.",
        sv: "Rummet är utcheckat. Tack för att du bodde hos oss - fråga gärna receptionen om du behöver något.",
    },
    err_invalid_title: {
        en: "This code isn’t active",
        sv: "Koden är inte aktiv",
    },
    err_invalid_body: {
        en: "The QR code may have been replaced. Please scan the current code in your room, or ask reception.",
        sv: "QR-koden kan ha bytts ut. Skanna den aktuella koden i ditt rum, eller fråga receptionen.",
    },
    err_none_title: {
        en: "Nothing to show yet",
        sv: "Inget att visa än",
    },
    err_none_body: {
        en: "Scan the QR code in your room to see your stay information.",
        sv: "Skanna QR-koden i ditt rum för att se information om din vistelse.",
    },
};
export function makeT(locale) {
    return (key) => {
        var _a, _b;
        const entry = UI_STRINGS[key];
        return (_b = (_a = entry[locale]) !== null && _a !== void 0 ? _a : entry[FALLBACK_LOCALE]) !== null && _b !== void 0 ? _b : key;
    };
}
